export default "__VITE_ASSET__d3f319cb__"